import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src3389300352/src/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DialogSurfaceThemeProvider"] */ "/codebuild/output/src3389300352/src/src/components/ui/dialog-surface-theme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdoptQuizBrandingNav"] */ "/codebuild/output/src3389300352/src/src/features/adopt-quiz/components/AdoptQuizBrandingNav.tsx");
